export type Stat = {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '6', label: 'Complete Coaching Volumes' },
  { value: '120', label: 'Ready-to-Coach Sessions' },
  { value: '150', label: 'Drills & Conditioning Activities' },
  { value: '50', label: 'Race Simulation Workouts' },
  { value: '100', label: 'Mistakes & Corrections' },
  { value: '40', label: 'Emergency Sessions' },
]
